<template lang="pug">
  .recommended-goods-skeleton-container
    SkeletonItem(className='recommended-goods-skeleton-title')
    .recommended-goods-skeleton-list
      .recommended-goods-skeleton-list-item-area
        SkeletonItem(className='recommended-goods-skeleton-list-item')
        SkeletonItem(className='recommended-goods-skeleton-list-btn')
      .recommended-goods-skeleton-list-item-area
        SkeletonItem(className='recommended-goods-skeleton-list-item')
        SkeletonItem(className='recommended-goods-skeleton-list-btn')
      .recommended-goods-skeleton-list-item-area
        SkeletonItem(className='recommended-goods-skeleton-list-item')
        SkeletonItem(className='recommended-goods-skeleton-list-btn')
</template>

<script>
import SkeletonItem from '@/components/skeleton-item';

export default {
  name: 'RecommendedGoodsSkeleton',
  components: {
    SkeletonItem,
  },
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.recommended-goods-skeleton-container {
  padding: 0.12rem 0.16rem 0.15rem;
  width: 100%;
  background-image:
    linear-gradient(
      180deg,
      rgba(255, 252, 238, 1) 0%,
      rgba(255, 252, 238, 1) 100%
    );
  border-radius: 0.16rem;
  border: 0.01rem solid #fff;
  box-sizing: border-box;

  .recommended-goods-skeleton-title {
    width: 1.38rem;
    height: 0.2rem;
  }

  .recommended-goods-skeleton-list {
    display: flex;
    justify-content: space-between;
    margin-top: 0.1rem;
    padding: 0 0.04rem;
  }

  .recommended-goods-skeleton-list-item {
    width: 0.84rem;
    height: 0.54rem;
  }

  .recommended-goods-skeleton-list-btn {
    height: 0.24rem;
    margin-top: 0.08rem;
    width: 0.84rem;
  }

  .recommended-goods-skeleton-progress {
    margin-top: 0.12rem;
    width: 100%;
    height: 0.27rem;
  }
}
</style>
